import axios from 'axios'
export const SUBSCRIBE_NEW_USER = 'SUBSCRIBE_NEW_USER'
export const GET_ALL_MARKETPLACE_PRODUCTS = 'GET_ALL_MARKETPLACE_PRODUCTS'
export const GET_ONE_MARKETPLACE_PRODUCT = 'GET_ONE_MARKETPLACE_PRODUCT'
export const GET_PLANS = 'GET_PLANS'
export const PURCHASE_PRODUCT = 'PURCHASE_PRODUCT'

export const subscribeNewUser = (token, planId, amount, email) => async dispatch => {
  const url = stripeUrl()
  const res = await axios.post(`${url}/subscribe`, { token, planId, amount, email })
  // console.log(res)
  dispatch({ type: SUBSCRIBE_NEW_USER, payload: res.data })
}

export const getAllMarketplaceProducts = () => async dispatch => {
  const url = stripeUrl()
  const res = await axios.get(`${url}/products`)
  // console.log(res)
  dispatch({ type: GET_ALL_MARKETPLACE_PRODUCTS, payload: res.data.body })
}

export const getMarketPlaceProduct = (sku) => async dispatch => {
  const url = stripeUrl()
  const res = await axios.get(`${url}/products/${sku}`)
  // console.log(res.data.body)
  dispatch({ type: GET_ONE_MARKETPLACE_PRODUCT, payload: res.data.body })
}

export const getAllPlans = () => async dispatch => {
  const url = stripeUrl()
  const res = await axios.get(`${url}/plans`)
  // console.log(res)
  dispatch({ type: GET_PLANS, payload: res.data })
}

// skuIds - An array of item ids
export const purchaseProducts = (stripeCustomerId, items) => async dispatch => {
  const url = stripeUrl()
  const res = await axios.post(`${url}/products`, {
    customerId: stripeCustomerId,
    items: items.map(i => {
      return {
        parent: i.id,
        quantity: i.quantity
      }
    })
  })
  // console.log(res)
  dispatch({ type: PURCHASE_PRODUCT, payload: res.data })
}

const stripeUrl = () => {
  const hostname = window && window.location && window.location.hostname ? window.location.hostname : ''
  let api = ''

  switch (hostname) {
    case 'app.postured.io':
      api = STRIPE_URL.PROD
      break
    default:
      api = STRIPE_URL.DEV
      break
  }
  return api
}

const STRIPE_URL = {
  DEV: 'https://luqz67eyte.execute-api.us-west-2.amazonaws.com/dev',
  PROD: 'https://v9467ejnvg.execute-api.us-west-2.amazonaws.com/prod'
}



// WEBPACK FOOTER //
// ./src/redux/actions/stripeActions.js